import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NotFound from "../notFound";
import Login from "../login/login";
import Register from "../login/Register";
import ProtectedRoute from "./ProtectedRoute";
import AdminLayout from "../components/AdminLayout";
import Dashboard from "../pages/Dashboard";
import Projects from "../pages/Projects";
import EmployeesList from "../pages/Employees/employeesList";
import Access from "../pages/Access/Access";
import MyServers from "../pages/MyServers/MyServers";
import FileManager from "../pages/Files/FileManager";
import SubdomainsPage from "../pages/Subdomains/SubdomainsPage";
import DockerPage from "../pages/Docker/DockerPage";
import ProjectServersPage from "../pages/ProjectServersPage";
import DeployPage from "../pages/Deploy/DeployPage";
import DeployHome from "../pages/Deploy/DeployHome";
import Terminal from "../pages/Terminal/Terminal";
import BoardsList from "../pages/Boards/BoardsList";
import Board from "../pages/Boards/Board";
import BoardSettings from "../pages/Boards/BoardSettings";
import WorkspacesAdmin from "../pages/Boards/WorkspacesAdmin";
import DashboardsList from "../pages/Boards/DashboardsList";
import DashboardViewer from "../pages/Boards/DashboardViewer";
import SharedBoard from "../pages/SharedBoard/SharedBoard";
import PermissionsPage from "../pages/Permissions/PermissionsPage";
import AppsLauncher from "../pages/AppsLauncher/AppsLauncher";
import SystemSettingsPage from "../pages/SystemSettings/SystemSettingsPage";

const RouteHandler = () => {
  return (
    <Suspense
      fallback={<div className="loader-div fullLoaderRoute">...loading</div>}
    >
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          {/* Public self-service registration — admin approves under Audit & Access → Users. */}
          <Route path="/register" element={<Register />} />
          {/* Public read-only share-link viewer — NO auth required. */}
          <Route path="/share/:token" element={<SharedBoard />} />
          <Route element={<ProtectedRoute />}>
            {/* Full-screen terminal — no AdminLayout wrapper */}
            <Route
              path="/terminal/:projectId/:serverId"
              element={<Terminal />}
            />
            <Route element={<AdminLayout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/projects" element={<Projects />} />
              <Route
                path="/projects/:projectId/servers"
                element={<ProjectServersPage />}
              />
              <Route path="/boards" element={<BoardsList />} />
              <Route path="/boards/:boardId" element={<Board />} />
              <Route path="/board-settings" element={<BoardSettings />} />
              <Route path="/workspaces" element={<WorkspacesAdmin />} />
              <Route path="/dashboards" element={<DashboardsList />} />
              <Route path="/dashboards/:id" element={<DashboardViewer />} />
              <Route path="/servers" element={<MyServers />} />
              <Route path="/docker" element={<DockerPage />} />
              <Route path="/deploy" element={<DeployHome />} />
              <Route
                path="/files/:projectId/:serverId"
                element={<FileManager />}
              />
              <Route
                path="/subdomains/:projectId/:serverId"
                element={<SubdomainsPage />}
              />
              <Route path="/deploy/:projectId" element={<DeployPage />} />
              <Route path="/employees" element={<EmployeesList />} />
              <Route path="/permissions" element={<PermissionsPage />} />
              <Route path="/system-settings" element={<SystemSettingsPage />} />
              <Route path="/apps" element={<AppsLauncher />} />
              <Route path="/logs" element={<Access />} />
            </Route>
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </Suspense>
  );
};

export default RouteHandler;
